var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"logo-box"}),_c('p',{staticClass:"remark"},[_vm._v(_vm._s(_vm.remark))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }